import { render } from "./Pets.vue?vue&type=template&id=8f2a5aea&scoped=true"
import script from "./Pets.vue?vue&type=script&lang=js"
export * from "./Pets.vue?vue&type=script&lang=js"

import "./Pets.vue?vue&type=style&index=0&id=8f2a5aea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2a5aea"]])

export default __exports__